export default __webpack_public_path__ + "37182960c24c38d95f2d6be88e2f6736.png";